import { Grid } from '@mui/material'
import { Child } from '../../../../containers/common/child'
import { UnitTitle } from './unitTitle'
import { OperationId } from '../../../../containers/common/constant/operationLog'
import { GetCategoryMstDto } from '../../../../dataAccess/webApi/dto/categoryMstDto'
import { memberModifyChildDailyRhythmUrl } from '../../../../containers/common/constant/appUrl'
import styled from '@emotion/styled'
import { MemberDecodeMst } from '../../../../containers/member/memberService'
import { translate } from '../../../../i18n'
import { Flag } from '../../../../containers/common/constant/classification'

export const CATEGORY_NAMES = [
  'bedTime',
  'wakeupTime',
  'napTime',
  'napStartTime',
  'napEndTime',
  'putToSleep',
  'fallAsleep',
  'excretion',
]

interface ChildDailyRhythmUnitProps {
  child?: Child
  sectionLabel: string
  categoryMst?: GetCategoryMstDto[]
  hideLink?: boolean
  LabelItem: any
  ValueItem: any
  decodeMst: MemberDecodeMst | null
}

const getLabelByValue = (valueLabels: { value: string; label: string }[] | null, value: string): string => {
  if (!valueLabels) {
    return ''
  }
  const valueLabel = valueLabels.find((valueLabel) => valueLabel.value === value)
  return valueLabel ? valueLabel.label : ''
}

export const ChildDailyRhythmUnit = (props: ChildDailyRhythmUnitProps) => {
  const { categoryMst, child, sectionLabel, LabelItem, ValueItem, decodeMst } = props
  if (child == null || categoryMst == null || categoryMst.length === 0) return null

  const targetCategories = categoryMst
    ?.filter((value) => CATEGORY_NAMES.includes(value.category) && value.displayCitizen === Flag.ON)
    .sort((a, b) => CATEGORY_NAMES.indexOf(a.category) - CATEGORY_NAMES.indexOf(b.category))

  if (targetCategories == null || targetCategories.length === 0) return null

  const categoryMap: { [key: string]: GetCategoryMstDto } = {}
  targetCategories?.forEach((e) => (categoryMap[e.category] = e))

  const ChildContentAttribute = styled(Grid)({
    padding: '0 0 0 3rem',
  })

  const unSetLabel = translate('system.childContent.label.notSet')

  return (
    <>
      <UnitTitle
        title={sectionLabel}
        linkTo={memberModifyChildDailyRhythmUrl.url(child.childId)}
        operationLog={{ operationId: OperationId.OP_00000189 }}
        hideLink={props.hideLink}
      />
      <Grid container>
        <ChildContentAttribute container>
          {targetCategories.map((c, _) => {
            return (
              <DataRow
                key={c.category}
                category={c}
                child={child}
                LabelItem={LabelItem}
                ValueItem={ValueItem}
                decodeMst={decodeMst}
                unSetLabel={unSetLabel}
              />
            )
          })}
        </ChildContentAttribute>
      </Grid>
    </>
  )
}

interface DataRowProps {
  category: GetCategoryMstDto
  child: Child
  LabelItem: any
  ValueItem: any
  decodeMst: MemberDecodeMst | null
  unSetLabel: string
}

const DataRow = ({ category, child, LabelItem, ValueItem, decodeMst, unSetLabel }: DataRowProps) => {
  const key = category.category as keyof Child
  const label = category.altCategoryName ?? category.name
  switch (key) {
    //時間系の項目
    case 'bedTime':
    case 'wakeupTime':
    case 'napStartTime':
    case 'napEndTime':
      return (
        <>
          {label != null && label !== '' && <LabelItem>{label}</LabelItem>}
          <ValueItem>{child[key] ? child[key]!.slice(0, 5) : unSetLabel}</ValueItem>
        </>
      )
    //カテゴリーマスタ経由の項目
    case 'napTime':
      //decode_mst(nap_time)を経由して変換
      const napTimeValueLabels = decodeMst
        ? decodeMst.napTime.map((item) => {
            return {
              value: item.code,
              label: item.name,
            }
          })
        : null
      return (
        <>
          {label != null && label !== '' && <LabelItem>{label}</LabelItem>}
          <ValueItem>
            {child[key] && napTimeValueLabels ? getLabelByValue(napTimeValueLabels, child[key]!) : unSetLabel}
          </ValueItem>
        </>
      )
    case 'putToSleep':
      //decode_mst(put_to_sleep)を経由して変換
      const putToSleepValueLabels = decodeMst
        ? decodeMst.putToSleep.map((item) => {
            return {
              value: item.code,
              label: item.name,
            }
          })
        : null
      return (
        <>
          {label != null && label !== '' && <LabelItem>{label}</LabelItem>}
          <ValueItem>
            {child[key] && putToSleepValueLabels ? getLabelByValue(putToSleepValueLabels, child[key]!) : unSetLabel}
          </ValueItem>
        </>
      )
    case 'fallAsleep':
      //decode_mst(fall_asleep)を経由して変換
      const fallAsleepValueLabels = decodeMst
        ? decodeMst.fallAsleep.map((item) => {
            return {
              value: item.code,
              label: item.name,
            }
          })
        : null
      return (
        <>
          {label != null && label !== '' && <LabelItem>{label}</LabelItem>}
          <ValueItem>
            {child[key] && fallAsleepValueLabels ? getLabelByValue(fallAsleepValueLabels, child[key]!) : unSetLabel}
          </ValueItem>
        </>
      )
    case 'excretion':
      //decode_mst(excretion)を経由して変換
      const excretionValueLabels = decodeMst
        ? decodeMst.excretion.map((item) => {
            return {
              value: item.code,
              label: item.name,
            }
          })
        : null
      return (
        <>
          {label != null && label !== '' && <LabelItem>{label}</LabelItem>}
          <ValueItem>
            {child[key] && excretionValueLabels ? getLabelByValue(excretionValueLabels, child[key]!) : unSetLabel}
          </ValueItem>
        </>
      )
    default:
      return null
  }
}